import { useNextRouterContext } from "@faire/deprecated-retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { useSettingEnhanceLispPrefetch } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnhanceLispPrefetch";
import search from "@faire/web-api--source/routes/www/search";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useEffect } from "react";

import { getSuggestedTermsHeader } from "../consts";

import { ISuggestionSections } from "./Interfaces";

export const usePrefetchSuggestions = (suggestions: ISuggestionSections) => {
  const enableEnhanceLispPrefetch = useSettingEnhanceLispPrefetch();
  const { strictLocalize } = useStrictLocalization();
  const { prefetch } = useNextRouterContext();

  useEffect(() => {
    const firstSuggestedTerm =
      suggestions[getSuggestedTermsHeader(strictLocalize)]?.[0];
    if (firstSuggestedTerm) {
      if (enableEnhanceLispPrefetch) {
        const q = firstSuggestedTerm.searchData.query;
        prefetch(search({ q }));
      }
    }
  }, [suggestions, prefetch, enableEnhanceLispPrefetch]);
};
